<h1 mat-dialog-title>You have not submitted your work yet.</h1>

<mat-dialog-content class="max-w-screen-sm">
  Are you sure you want to navigate away? You will lose unsaved changes.
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close(false)">No, stay here</button>
  <button mat-raised-button color="warn" (click)="close(true)">Yes, discard my changes</button>
</mat-dialog-actions>
